import React, { useState } from 'react';
import { useEffect } from 'react'; 
import { useForm } from 'react-hook-form';
import {
  ColTitle,
  ErrorMsg,
  Form,
  Label,
  MultiSelect,
  RRow,
} from './Register.style';
import FW from '../../config/word.json';
import MainLayout from '../../components/Layouts/Main/MainLayout.index.js';
import {getJMasterAll, getUser} from "../../api/project";
import { useLocation } from 'react-router-dom';
import { updateUserFromWeb } from "../../api/project";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


function REGISTER(props) {

    const query = new URLSearchParams(useLocation().search);
    const userId = query.get('userId');

    const { register, handleSubmit, reset, setValue, formState: { errors }, } = useForm();
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const navigate = useNavigate();

    const handleGroupChange = (e) => {
      const options = e.target.options;
      const selected = [];
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          selected.push(options[i].value);
        }
      }
      setSelectedGroups(selected);
      setValue('groupName', selected.join(','));
    };

    const onSubmit = async (data) => {
        try {
            const jUser = {
                userId: data.userId,
                userFlg: data.userFlg,
                groupName: data.groupName,
                imageUrl: data.imageUrl,
                maxSendAdCnt: data.maxSendAdCnt,
            };
            const response = await updateUserFromWeb(jUser);
            if (response.code === 200) {
                toast.success('更新に成功しました！');
                //navigate('/home');
            }
        } catch (error) {
            setIsError(true);
            setErrorMessage(error.response?.data?.message || '更新に失敗しました');
        }
    };

  // マスタデータから所属団体リストを取得
  useEffect(() => {
    const fetchMaster = async () => {
      try {
        const res = await getJMasterAll();
        const masterList = res.data || [];
        const groups = masterList
          .filter(item => item.key_value === 'group_name' && item.str_value)
          .map(item => item.str_value);
        setGroupOptions(['所属団体(未選択)', ...groups]);
      } catch (e) {
        console.error('マスタデータ取得失敗:', e);
      }
    };
    fetchMaster();
  }, []);

  // ✅ 初期表示時にAPIからデータ取得
  useEffect(() => {
    if (!userId) {
        navigate('/');
        return;
    }
    const fetchData = async () => {
      try {
        if (!userId) return;
        const res = await getUser(userId);
        const data = res.data;
        const loadedGroups = data.groupName
          ? data.groupName.split(',').map(g => g.trim()).filter(g => g)
          : [];
        setSelectedGroups(loadedGroups);

        const formData = {
          userId: data.userId || '',
          twitterName: data.twitterName || '',
          userName: data.userName || '',
          userKana: data.userKana || '',
          userFlg: data.userFlg?.toString() || '1',
          groupName: loadedGroups.join(','),
          searchKeyword: data.searchKeyWord || '',
          selfIntroduction: data.selfIntroduction || '',
          email: data.email || '',
          birthday: data.birthday || '',
          tel: data.tel || '',
          imageUrl: data.imageUrl || '',
          authFlg: (data.authFlg?.toString() || '0') !=='1' ? '0' : '1',
          cancelFlg: data.cancelFlg?.toString() || '0',
          maxSendAdCnt: data.maxSendAdCnt || '',
        };

        reset(formData);
      } catch (error) {
        console.error('初期データ取得失敗:', error);
        setIsError(true);
        setErrorMessage('初期データの取得に失敗しました');
      }
    };

    fetchData();
  }, [reset, userId]);

  return (
    <MainLayout>
      <div style={{ marginBottom: '10px', marginTop: '10px',　textAlign: 'left', color: '#00C6BB'}}>
        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
        推しごとカレンダーからユーザー情報詳細
        </span>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        
        {/* ユーザID */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_N}</ColTitle>
          <span>
            <input
              type="text"
              {...register('userId')}
              aria-label="userId"
              disabled
            />
          </span>
          {errors.userId && <ErrorMsg>{errors.userId.message}</ErrorMsg>}
        </RRow>

        {/* Xユーザ名 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_TWITTER_NAME}</ColTitle>
          <span>
            <input
              type="text"
              {...register('twitterName')}
              aria-label="twitterName"
              disabled
            />
          </span>
          {errors.twitterName && <ErrorMsg>{errors.twitterName.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ名 */}
        <RRow>
        <ColTitle>{FW.F_W_SYS_USER_NAME}</ColTitle>
        <span>
            <input
            type="text"
            {...register('userName')}
            placeholder={FW.F_W_SYS_USER_NAME}
            aria-label="userName"
            disabled
            />
        </span>
        {errors.twitterName && <ErrorMsg>{errors.twitterName.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ仮名 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_KANA}</ColTitle>
          <span>
            <input
              type="text"
              {...register('userKana')}
              aria-label="userKana"
              disabled
            />
          </span>
          {errors.userKana && <ErrorMsg>{errors.userKana.message}</ErrorMsg>}
        </RRow>

        {/* ユーザ種類 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_USER_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="1"
              {...register('userFlg')}
              defaultChecked
            />
            <Label htmlFor="pro">{FW.F_W_SYS_USER_FLG_PRO}</Label>
            <input
              type="radio"
              value="2"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_CUSTOM}</Label>
            <input
              type="radio"
              value="3"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_JYANSOU}</Label>
            <input
              type="radio"
              value="4"
              {...register('userFlg')}
            />
            <Label htmlFor="custom">{FW.F_W_SYS_USER_FLG_JYANBAR}</Label>
          </span>
          {errors.userFlg && <ErrorMsg>{errors.userFlg.message}</ErrorMsg>}
        </RRow>

        {/* 所属団体（複数選択可） */}
        <RRow>
        <ColTitle>{FW.F_W_SYS_GROUP_NAME}</ColTitle>
        <span>
            <input type="hidden" {...register('groupName')} />
            <MultiSelect
            multiple
            value={selectedGroups}
            onChange={handleGroupChange}
            >
            {groupOptions.map(group => (
                <option key={group} value={group}>{group}</option>
            ))}
            </MultiSelect>
        </span>
        </RRow>

        {/* 検索キーワード */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_SEARCH_KEYWORD}</ColTitle>
          <span>
            <input
              type="text"
              {...register('searchKeyword')}
              placeholder={FW.F_W_SYS_SEARCH_KEYWORD}
              aria-label="searchKeyword"
              disabled
            />
          </span>
        </RRow>

        {/* 自己紹介 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_SELF_INTRODUCTION}</ColTitle>
          <span>
            <textarea
              {...register('selfIntroduction')}
              placeholder={FW.F_S_P_SELF_INTRODUCTION}
              aria-label="selfIntroduction"
              rows={3}
              cols={45}
              disabled
            />
          </span>
        </RRow>

        {/* メールアドレス */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_E}</ColTitle>
          <span>
            <input
              type="email"
              {...register('email')}
              placeholder={FW.F_W_SYS_E}
              aria-label="email"
              disabled
            />
          </span>
          {errors.email && <ErrorMsg>{errors.email.message}</ErrorMsg>}
        </RRow>

        {/* 生年月日 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_B}</ColTitle>
          <span>
            <input
              type="text"
              {...register('birthday')}
              disabled
            />
          </span>
          {errors.birthday && <ErrorMsg>{errors.birthday.message}</ErrorMsg>}
        </RRow>

        {/* 電話番号 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_TEL}</ColTitle>
          <span>
            <input
              type="tel"
              {...register('tel')}
              placeholder={FW.F_W_SYS_TEL}
              aria-label="tel"
              disabled
            />
          </span>
          {errors.tel && <ErrorMsg>{errors.tel.message}</ErrorMsg>}
        </RRow>

        {/* 画像URL */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_IMAGE_URL}</ColTitle>
          <span>
            <input
              type="url"
              {...register('imageUrl')}
              placeholder={FW.F_S_P_IMAGE_URL}
              aria-label="imageUrl"
            />
          </span>
        </RRow>

        {/* 認証flg */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_AUTH_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="0"
              {...register('authFlg')}
              defaultChecked
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_UNAUTH}</Label>
            <input
              type="radio"
              value="2"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_2}</Label>
            <input
              type="radio"
              value="3"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth0">{FW.F_W_SYS_AUTH_FLG_3}</Label>
            <input
              type="radio"
              value="1"
              {...register('authFlg')}
              disabled
            />
            <Label htmlFor="auth1">{FW.F_W_SYS_AUTH_FLG_AUTH}</Label>
          </span>
          {errors.authFlg && <ErrorMsg>{errors.authFlg.message}</ErrorMsg>}
        </RRow>

        {/* 退会flg */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_CANCEL_FLG}</ColTitle>
          <span>
            <input
              type="radio"
              value="0"
              {...register('cancelFlg')}
              defaultChecked
              disabled
            />
            <Label htmlFor="cancel0">{FW.F_W_SYS_CANCEL_FLG_ACTIVE}</Label>
            <input
              type="radio"
              value="1"
              {...register('cancelFlg')}
              disabled
            />
            <Label htmlFor="cancel1">{FW.F_W_SYS_CANCEL_FLG_CANCELLED}</Label>
          </span>
          {errors.cancelFlg && <ErrorMsg>{errors.cancelFlg.message}</ErrorMsg>}
        </RRow>

        {/* 最大広告送信数 Push通知 */}
        <RRow>
          <ColTitle>{FW.F_W_SYS_Push_MAX_CNT}</ColTitle>
          <span>
            <input
              type="text"
              {...register('maxSendAdCnt')}
              style={{ textAlign: 'right' }}
              placeholder={FW.F_W_SYS_Push_MAX_CNT}
              aria-label="maxSendAdCnt"
            />
          </span>
          {errors.maxSendAdCnt && <ErrorMsg>{errors.maxSendAdCnt.message}</ErrorMsg>}
        </RRow>

        {/* レコード作成日時 */}
        {/* 自動設定されるので入力不要 */}

        {/* レコード更新日時 */}
        {/* 自動設定されるので入力不要 */}

        <div className='foot'>
          <input type="submit" value={FW.F_W_REGISTER_REGISTER} aria-label="submit" />
        </div>

        {isError && <ErrorMsg>{errorMessage}</ErrorMsg>}
        <div style={{ height: '100px' }} />
      </Form>
    </MainLayout>
  );
}

export default REGISTER;
